import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../features/auth";


const initialState: ITableButtonsRow = {
    downloadSelectedDocumentsButtonIsClicked: false
}

export const tableButtonsRowSlice = createSlice({
    name: 'tableButtonsRow',
    initialState,
    reducers: {
        setDownloadSelectedDocumentsButtonIsClicked(state, action: PayloadAction<any>) {
            state.downloadSelectedDocumentsButtonIsClicked = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return initialState
        })
    },
})

export const {
    setDownloadSelectedDocumentsButtonIsClicked
} = tableButtonsRowSlice.actions
export const tableButtonsRowReducer = tableButtonsRowSlice.reducer;
